import { BlockService } from '@blocksuite/block-std';
export class EmbedHtmlService extends BlockService {
}
//# sourceMappingURL=embed-html-service.js.map